<template>
  <b-field :label="$t('MemberId')" data-test-id="memberIdField">
    <b-input
      :model-value="displayValue"
      disabled
    ></b-input>
  </b-field>
</template>
<script lang="ts">
export default {
  props: { value: Number },
  computed: {
    displayValue(): string {
      return this.value ? this.value.toString() : this.$t('SystemGenerated').toString();
    },
  },
};
</script>
